<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import BIReportForm from '@/components/power-bi/BIReportForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        company_id: selectedCompanyId.value,
        reporting_account: '',
        reporting_account_nr: '',
        account_mapping: '',
        measurement_calculation: '',
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.powerbi.setup.store')"
        :query-key="[QueryKey.POWER_BI, selectedCompanyId]"
        title="power_bi.create_power_bi_report"
        button-text="power_bi.create_power_bi_report"
    >
        <BIReportForm :form="form" />
    </DialogForm>
</template>
